import { Flex, Text } from "@similarweb/ui-components/foundations";

import { BookMeetingButtonWithAccountManagerGuard } from "app/pages/sales-intelligence/common-components/BookMeetingButton/BookMeetingButtonWithAccountManagerGuard";

import { StyledSuccessBannerWrapper, SuccessContentWrapper, StyledIcon } from "./styles";

type ModalContentProps = {
    title: string;
    subTitle: string;
};

const SuccessBanner = ({ title, subTitle }: ModalContentProps) => {
    return (
        <StyledSuccessBannerWrapper>
            <Flex>
                <StyledIcon iconName={"reaching-out-state"} />
            </Flex>
            <SuccessContentWrapper>
                <Text fontVariant={"subtitle1"}>{title}</Text>
                <Text fontVariant={"body2"}>{subTitle}</Text>
                <BookMeetingButtonWithAccountManagerGuard
                    label="contact-us-upgrade-banner-success"
                    buttonType="primary"
                />
            </SuccessContentWrapper>
        </StyledSuccessBannerWrapper>
    );
};

export default SuccessBanner;
